import { Layer, Source } from '@vis.gl/react-maplibre';
import dayjs from 'dayjs';
import { Fragment, useEffect, useState } from 'react';

import ParkingIcon from '@/assets/icons/map/parking.svg?url';
import testParkingData from '@/data/testParking.json';
import { useMapImages } from '@/hooks/useMapImages';
import { PG_FEATURESERV_URL } from '@/setup/pg-featureserv';
import { MapIcon } from '@/types/MapIcon';
import { MapLayer } from '@/types/MapLayer';

export const PARKING_SYMBOL_COUNT_LAYER = `${MapLayer.PARKING}_SYMBOL_COUNT_LAYER`;
export const PARKING_SYMBOL_ICON_LAYER = `${MapLayer.PARKING}_SYMBOL_ICON_LAYER`;

export function ParkingLayer() {
  useMapImages({
    images: [{ name: MapIcon.PARKING, url: ParkingIcon, width: 36, height: 36 }],
  });

  const [timestamp, setTimestamp] = useState<string>(dayjs().toISOString());

  useEffect(() => {
    const interval = setInterval(
      () => {
        setTimestamp(dayjs().toISOString());
      },
      5 * 60 * 1000,
    );

    return () => clearInterval(interval);
  }, []);

  return (
    <Fragment>
      <Source
        key={MapLayer.PARKING}
        data={`${PG_FEATURESERV_URL}/collections/frontend.parking/items.json?timestamp=${timestamp}`}
        id={MapLayer.PARKING}
        type="geojson"
      >
        <Layer
          key={MapLayer.PARKING}
          id={MapLayer.PARKING}
          type="circle"
          paint={{
            'circle-color': '#005a8c',
            'circle-radius': ['interpolate', ['exponential', 0.5], ['zoom'], 10, 9, 16, 18],
          }}
        />

        <Layer
          key={PARKING_SYMBOL_COUNT_LAYER}
          filter={['==', ['typeof', ['get', 'short_term_parking_free']], 'number']}
          id={PARKING_SYMBOL_COUNT_LAYER}
          type="symbol"
          layout={{
            'text-font': ['Noto Sans Bold'],
            'text-field': ['get', 'short_term_parking_free'],
            'text-size': ['interpolate', ['exponential', 0.5], ['zoom'], 10, 7, 16, 14],
          }}
          paint={{
            'text-color': 'white',
          }}
        />

        <Layer
          key={PARKING_SYMBOL_ICON_LAYER}
          filter={['!=', ['typeof', ['get', 'short_term_parking_free']], 'number']}
          id={PARKING_SYMBOL_ICON_LAYER}
          type="symbol"
          layout={{
            'icon-image': MapIcon.PARKING,
            'icon-size': ['interpolate', ['exponential', 0.5], ['zoom'], 10, 0.5, 16, 1],
          }}
        />
      </Source>

      {/* Test Layer mit Parking Icon in der Mitte - später löschen */}
      <Source key="PARKING_TEST" data={testParkingData as GeoJSON.FeatureCollection} id="PARKING_TEST" type="geojson">
        <Layer
          key="PARKING_TEST"
          id="PARKING_TEST"
          type="symbol"
          layout={{
            'icon-image': MapIcon.PARKING,
            'icon-size': ['interpolate', ['exponential', 0.5], ['zoom'], 10, 0.5, 16, 1],
            'icon-allow-overlap': true,
          }}
        />
      </Source>
    </Fragment>
  );
}
